
import { defineComponent, PropType } from 'vue'
import Code from './Code.vue';

export default defineComponent({
  name: 'Details',
  components: {
    Code,
  },
  props: {
    font: {
      type: String,
      required: true
    },
    version: {
      type: Number,
    },
    name: {
      type: String,
      required: true
    },
    codepoint: {
      type: String,
    },
    categories: {
      type: Array as PropType<string[]>,
    },
    tags: {
      type: Array as PropType<string[]>,
    },
    popularity: {
      type: Number,
      default: 0,
    },
    sizes_px: {
      type: Array as PropType<number[]>,
    },
    svgAssetUrl: {
      type: String,
    },
    pngAssetUrl: {
      type: String,
    },
  },
  setup(props) {
    const htmlCode = () => `<span class="material-icons">
  ${props.name}
</span>`
    const reactCode = () => `<span className="material-icons">
  ${props.name}
</span>`
    const cssCode = (selector: string) => `&::${selector} {
  font-family: 'Material Icons';
  content: "\\${props.codepoint}";
}`
    const download = async (url: string) => {
      try {
        const response = await fetch(url)
        const blob = await response.blob()
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `${props.name}-${new URL(url).pathname.split('/').pop() || ''}`
        link.click()
        URL.revokeObjectURL(link.href)
      } catch (err) {
        console.error(err)
      }
    }
    return {
      download,
      htmlCode,
      reactCode,
      cssCode,
    }
  }
})
